export default __webpack_public_path__ + "static/l8-portfolio-img-1-3be346e0fc4339733c655f4a7059466d.png";